import logo from "./logo.svg";
import "./App.css";
import { createContext, useContext, useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import IconButton from "@mui/material/IconButton";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Badge from "@mui/material/Badge";
import { Route, Routes, useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";

// const API = "http://localhost:4000";

const API = "https://ecom-demo-ark.herokuapp.com";

const cartCtx = createContext();

const currencyFormatter = (number) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(
    number
  );

const INTIAL_CART = [];

// cart - [{pid, img, model, company, qty}, {pid, img, model, company, qty}]
function App() {
  const [cart, setCart] = useState(INTIAL_CART);

  useEffect(() => {
    fetch(`${API}/cart`)
      .then((data) => data.json())
      .then((latestCart) => setCart(latestCart));
  }, []);

  // + / - / AddToCart
  const updateCart = ({ mobile, action }) => {
    // /post -> setCart

    fetch(`${API}/cart?type=${action}`, {
      method: "PUT",
      body: JSON.stringify(mobile),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((data) => data.json())
      .then((latestCart) => setCart(latestCart));
  };

  const totatQty = cart
    .map((item) => item.qty)
    .reduce((sum, qty) => sum + qty, 0);

  const navigate = useNavigate();

  return (
    <div className="App">
      <cartCtx.Provider value={[cart, updateCart, setCart]}>
        <AppBar position="static">
          <Toolbar>
            <Button color="inherit" onClick={() => navigate("/")}>
              Home
            </Button>
            <IconButton
              style={{ marginLeft: "auto" }}
              color="inherit"
              aria-label="Cart"
              onClick={() => navigate("/cart")}
            >
              <Badge badgeContent={totatQty} color="secondary">
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
          </Toolbar>
        </AppBar>

        <Routes>
          <Route path="/" element={<PhoneList />} />
          <Route path="/cart" element={<Cart />} />
        </Routes>
      </cartCtx.Provider>
    </div>
  );
}

function Cart() {
  const [cart, updateCart, setCart] = useContext(cartCtx);

  const [open, setOpen] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    fetch(`${API}/cart`)
      .then((data) => data.json())
      .then((latestCart) => setCart(latestCart));
  }, []);

  const total = cart
    .map((item) => item.qty * item.price)
    .reduce((sum, item) => sum + item, 0);

  const navigate = useNavigate();

  const checkout = () => {
    fetch(`${API}/checkout`, {
      method: "POST",
      body: JSON.stringify(cart),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((data) => data.json())
      .then((latestCart) => setCart(latestCart))
      .then(() => setOpen(true))
      .then(() => setTimeout(() => navigate("/"), 1000));
  };

  return (
    <section className="cart-list">
      <h2>Purchase Items</h2>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert severity="success">
          <AlertTitle>Success</AlertTitle>
          Order <strong>Placed!</strong>
        </Alert>
      </Snackbar>
      <div className="card-list-container">
        {cart.map((mobile) => (
          <CartItem key={mobile._id} mobile={mobile} />
        ))}
        <div className="cart-checkout">
          <h1 className="cart-checkout-price">{currencyFormatter(total)}</h1>
          <button onClick={() => checkout()}>✔️ Checkout</button>
        </div>
      </div>
    </section>
  );
}

function CartItem({ mobile }) {
  const [cart, updateCart] = useContext(cartCtx);
  return (
    <div className="cart-item-container">
      <img src={mobile.img} alt={mobile.model} className="cart-item-picture" />
      <div>
        <h2 className="cart-item-name">{mobile.model}</h2>
        <p className="cart-item-company">{mobile.company}</p>
        <p className="cart-item-quantity">
          {/* <span>Quantity:</span>  */}
          <button onClick={() => updateCart({ mobile, action: "decrement" })}>
            ➖
          </button>{" "}
          {mobile.qty}{" "}
          <button onClick={() => updateCart({ mobile, action: "increment" })}>
            ➕
          </button>
        </p>
      </div>
      <p className="cart-item-price">
        {currencyFormatter(mobile.qty * mobile.price)}
      </p>
    </div>
  );
}

function PhoneList() {
  const [mobiles, setMobiles] = useState([]);

  useEffect(() => {
    fetch(`${API}/mobiles`)
      .then((data) => data.json())
      .then((mbs) => setMobiles(mbs));
  }, []);

  return (
    <div className="phone-list-container">
      {mobiles.map((mobile) => (
        <Phone key={mobile._id} mobile={mobile} />
      ))}
    </div>
  );
}

function Phone({ mobile }) {
  const [cart, updateCart] = useContext(cartCtx);
  return (
    <div className="phone-container">
      <img src={mobile.img} alt={mobile.model} className="phone-picture" />
      <h2 className="phone-name">{mobile.model}</h2>
      <p className="phone-company">{mobile.company}</p>
      <h2 className="phone-price">{currencyFormatter(mobile.price)}</h2>
      <button
        className="phone-add-cart"
        onClick={() => updateCart({ mobile, action: "increment" })}
      >
        Add to Cart
      </button>
    </div>
  );
}

export default App;
